<div class="container">
  <app-header></app-header>
  <div class="sub-container">
    <app-side-menu [class.opened]="(menuState | async)?.isOpen">
    </app-side-menu>
    <div class="main-content" [class.expanded]="!(menuState | async)?.isOpen">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
